import * as React from "react";
import { BarChart } from '@mui/x-charts';

const HorizontalBarChart = ({ chart_data, isFullWidth }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getChartData = () => {
        const xData = data?.map((d) => d?.xAxis);
        const yData = data?.map((d) => d?.yAxis);
        return { xData, yData };
    };

    const { xData, yData } = getChartData();

    const chartSetting = {
        xAxis: [
            {
                label: 'No of Players',
            },
        ],
        height: 360,
    };

    const valueFormatter = (value) => {
        return `${value}`;
    }

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data?.title || chart_data?.chart_name}</h3>
            <p>{chart_data?.description}</p>
            <BarChart
                dataset={data}
                series={[{ dataKey: 'yAxis', label: 'Players', valueFormatter }]}
                yAxis={[{
                    scaleType: 'band', 
                    dataKey: 'xAxis', 
                    tickPlacement: 'middle', 
                    tickLabelPlacement: 'middle', 
                    tickSize: 5,
                    tickLabelStyle: {
                        fill: '#555',
                        fontSize: 11,
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        textAnchor: 'end',
                        dominantBaseline: 'middle',
                        letterSpacing: '0.3px',
                    }
                }]}
                layout="horizontal"
                margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
                padding={{left: 0}}
                {...chartSetting}
            />
        </div>
    );

}

const styles = {
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
    cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
};

export default HorizontalBarChart;